module.exports = new __parcel__URL__("chainbreaker.8abed712.png").toString();